import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import Features from '../components/sections/Features';
import Team from '../components/sections/Team';
import Trust from '../components/sections/Trust';
import Pricing from '../components/sections/Pricing';
import Contact from '../components/sections/Contact';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <Services />
        <Features />
        <Team />
        <Trust />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}